<template>
  <div class="details-box">
    <el-dialog
      :before-close="handleClose"
      :title="details.title"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <div class="table-box">
        <el-table
          v-if="userModalDetails.sourceType == '3'"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="序号"
            type="index"
            width="80"
          ></el-table-column>
          <el-table-column
            align="center"
            label="课程名称"
            prop="courseName"
            show-overflow-tooltiplabel
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="学习完成人数"
            prop="finishNum"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template #default="scope">
              <el-button type="text" @click="goDetail(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else :data="tableData" style="width: 100%">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="姓名" prop="name">
            <template #default="scope">
              <span v-if="details.title == '从业人员'">{{
                scope.row.name
              }}</span>
              <span v-else-if="details.title == '项目负责人'">{{
                scope.row.certName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="证书编号" prop="certno">
            <template #default="scope">
              <span v-if="details.title == '从业人员'">{{
                scope.row.certno
              }}</span>
              <span v-else-if="details.title == '项目负责人'">{{
                scope.row.certNo
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期限" prop="yxqz"></el-table-column>
        </el-table>
        <div class="page-box">
          <el-pagination
            :page-size="10"
            :page-sizes="[10, 50, 100, 200]"
            :total="total"
            layout="total, sizes, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
      <CoursePersonnel
        :details="coursePersonnelDetails"
        @closeDialog="closeDialog"
      ></CoursePersonnel>
    </el-dialog>
  </div>
</template>
<script>
import { getCyry, getXmfzr } from "@/api/home/index";
import CoursePersonnel from "./coursePersonnel.vue";
import { dwCourseList } from "@/api/home/guild";

export default {
  components: { CoursePersonnel },
  props: ["details"],
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      total: 0,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      userModalDetails: {},
      coursePersonnelDetails: {
        dialogVisible: false,
      },
    };
  },
  watch: {
    details: {
      handler(newValue, oldValue) {
        // 这里不仅可以监听到对象引用的变化，还能监听到对象内部属性的变化
        this.dialogVisible = newValue.dialogVisible;
        this.xh_userInfo = JSON.parse(this.$Cookies.get("xh_userInfo"));
        this.userModalDetails = newValue.data;
        if (newValue.dialogVisible) {
          this.getById();
        }
      },
      deep: true, // 开启深度监听
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.pageNo = 1;
      this.params.pageSize = val;
      this.getById();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.params.pageNo = val;
      this.getById();
    },
    getById() {
      if (this.userModalDetails.sourceType == 1) {
        // 从业人员
        getCyry({ ...this.params, dw: this.xh_userInfo.user.dwmc }).then(
          (res) => {
            if (res.code == 200) {
              this.tableData = res.result.records || [];
              this.total = res.result.total;
            }
          },
        );
      }
      //
      if (this.userModalDetails.sourceType == 2) {
        // 项目负责人
        getXmfzr({
          ...this.params,
          certCompany: this.xh_userInfo.user.dwmc,
        }).then((res) => {
          if (res.code == 200) {
            this.tableData = res.result.records || [];
            this.total = res.result.total;
          }
        });
      }
      if (this.userModalDetails.sourceType == 3) {
        // 课程中心
        dwCourseList({
          ...this.params,
          company: this.xh_userInfo.user.dwmc,
          token: this.xh_userInfo.token,
        }).then((res) => {
          if (res.code == 0 && res.result) {
            this.tableData = res.result.records || [];
            this.total = res.result.total;
          }
        });
      }
    },
    goDetail(it) {
      this.coursePersonnelDetails.dialogVisible = true;
      this.coursePersonnelDetails.courseId = it.courseId;
    },
    closeDialog() {
      this.coursePersonnelDetails.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.details-box {
  .page-box {
    text-align: right;
  }
}
</style>
